import { PageWrapper } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

export function AppUnauthorized() {
  const { t } = useTranslation();

  return <PageWrapper>{t('auth.forbidden')}</PageWrapper>;
}
